import React, { useState } from "react";
import { makeStyles } from "@mui/styles";
import Dialog from "@mui/material/Dialog";
import Button from "@mui/material/Button";
import DialogContent from "@mui/material/DialogContent";
import { TextField, Box, Tooltip } from "@mui/material";
import { Bold } from "react-feather";
import Typography from "@mui/material/Typography";

const user = {
  avatar1: "/static/images/avatars/zippy.png",
  name: localStorage.getItem("user"),
  email: localStorage.getItem("email"),
  group: localStorage.getItem("group"),
};

const useStyles = makeStyles((theme) => ({
  root: {
    margin: "2px",
    width: 300,
  },

  btncenter: {
    display: "flex",
    justifyContent: "center",
    padding: "10px 30px",
    paddingLeft: 10,
  },

  label: {
    textAlign: "center",
    fontSize: "1em",
    paddingBottom: "12px",
  },

  text: {
    textAlign: "center",
  },

  header: {
    display: "flex",
    color: "black",
    paddingTop: "1rem",
    fontSize: 20,
    font: Bold,
    flexDirection: "column",
    alignItems: "center",
  },
}));

const customContentStyle = {
  width: "100%",
  maxWidth: "none",
};

function ImageUpload() {
  const classes = useStyles();
  const [cover, setCever] = useState();

  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    if (user.group === "admin") {
      setOpen(true);
    } else {
      setOpen(false);
    }
  };

  const handleClose = () => {
    setOpen(false);
  };

  const newBook = () => {
    const uploadData = new FormData();
    uploadData.append("cover", cover, cover.name);
    uploadData.append("user", user.name);
    const data = {
      cover: uploadData,
    };
    fetch(`${process.env.REACT_APP_API_URL}/api/books/`, {
      method: "POST",
      body: uploadData,
    })
      .then((res) => console.log(res))
      .then((data) => console.log(data), window.location.reload())
      .catch((error) => {
        window.location.reload();
      });
  };

  const [avatar, setAvatar] = React.useState([]);

  React.useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/api/orgimage/`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + window.localStorage.getItem("token"),
      },
    })
      .then((resp) => resp.json())
      .then((resp) => setAvatar(resp[0]))
      .catch((error) => {
        console.error(error);
      });
  }, []);
  return (
    <>
      <Tooltip
        title={user.group === "admin" ? "Upload organization logo" : "Only admins can upload"}
        arrow
      >
        <span>
          <Button
            variant="contained"
            color="primary"
            type="button"
            onClick={handleClickOpen}
            disabled={user.group !== "admin"}
            size="small"
            sx={{
              borderRadius: "40px",
              px: 2,
              py: 0.75,
              textTransform: "uppercase",
              fontWeight: 600,
              whiteSpace: "nowrap",
            }}
          >
            Upload Logo
          </Button>
        </span>
      </Tooltip>

      <Dialog
        open={open}
        onClose={handleClose}
        contentStyle={customContentStyle}
        fullWidth
        maxWidth="sm"
      >
        <Box textAlign="center">
          <img src={avatar ? avatar.cover : ""} height="100px" />
          <DialogContent>
            <Typography variant="caption" display="block" gutterBottom>
              Suggest size 200 X 60*
            </Typography>
            <TextField
              name="Cover"
              fullWidth
              placeholder="upload the image"
              sx={{ textAlign: "center", alignItems: "center" }}
              type="file"
              onChange={(evt) => setCever(evt.target.files[0])}
            />

            <div className={classes.btncenter}>
              <Tooltip
                title={cover ? "Save logo" : "Select an image to enable"}
                arrow
              >
                <span>
                  <Button
                    disabled={!cover}
                    color="primary"
                    variant="contained"
                    onClick={() => newBook()}
                    sx={{ borderRadius: "50px", px: 3, py: 1 }}
                  >
                    Save
                  </Button>
                </span>
              </Tooltip>
            </div>
          </DialogContent>
        </Box>
      </Dialog>
    </>
  );
}

export default ImageUpload;